import { ADMIN_API } from "./adminApi";
import { ApiOk } from "./adminCommon.types";

export type RoadmapColumn = "planejado" | "em_desenvolvimento" | "em_testes" | "publicado";

export type RoadmapCard = {
  id: number;
  title: string;
  description: string | null;
  column: RoadmapColumn;
  position: number;
  createdAt: string;
};

export const listRoadmapCards = async () => {
  const { data } = await ADMIN_API.get<ApiOk<RoadmapCard[]>>("/api/admin/roadmap");
  return data.data;
};

export const createRoadmapCard = async (payload: { title: string; description?: string; column: RoadmapColumn }) => {
  const { data } = await ADMIN_API.post<ApiOk<RoadmapCard>>("/api/admin/roadmap", payload);
  return data.data;
};

export const updateRoadmapCard = async (id: number, payload: { title?: string; description?: string }) => {
  const { data } = await ADMIN_API.put<ApiOk<RoadmapCard>>(`/api/admin/roadmap/${id}`, payload);
  return data.data;
};

export const moveRoadmapCard = async (id: number, column: RoadmapColumn) => {
  const { data } = await ADMIN_API.patch<ApiOk<RoadmapCard>>(`/api/admin/roadmap/${id}/move`, { column });
  return data.data;
};

export const deleteRoadmapCard = async (id: number) => {
  await ADMIN_API.delete(`/api/admin/roadmap/${id}`);
};
